import { render, staticRenderFns } from "./ProvinceIndexesView.vue?vue&type=template&id=84184a6e&"
import script from "./ProvinceIndexesView.vue?vue&type=script&lang=js&"
export * from "./ProvinceIndexesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports